export const ACCESS_TOKEN_NAME = 'access_token'
export const AUTHORRITIES_NAME = 'authorities'
export const USER_NAME = 'userName'